import {createTheme} from "@mui/material";
import "../../assets/fonts/fonts.module.css";

const theme = createTheme({
        breakpoints: {
            values: {
                xs: 0,
                mobS: 330,
                mobM: 420,
                br480: 480,
                mobL: 500,
                sm: 600,
                br768: 768,
                md: 900,
                br1024: 1024,
                lg: 1200,
                xl: 1536,
                // xxl: 1920,
            },
        },
        palette: {
            primary: {
                main: "#A01EF4", //sidebar active button
                light: "#CBA1F9", //checkboxes, select, plus button
                contrastText: "#FFFFFF",
            },
            secondary: {
                main: "#3383F8", //select text
                light: "#2191ff", //login button
                dark: "#5786FF", //table titles color
            },
            text: {
                primary: "#B27394",
                secondary: "#634D58",
                medium: '#792e55',
            },
            colors: {
                disabled: "#f9f9fa",
                onlyDesktop: "#575EF3",
            }
        },
        typography: {
            fontSize: 16,
            fontWeightRegular: 400,
            fontWeightBold: 600,
            fontFamily: "'Hellix', sans-serif",
            h1: {
                //main title
                fontSize: "2.7rem",
                fontFamily: "'Hellix-SemiBold', sans-serif",
                color: '#0B0A1A',
                letterSpacing: 0,
                lineHeight: 0.9,
            },
            h2: {
                //Pixel connection, upload file title
                fontSize: '2.4rem',
                fontWeight: 500,
                color: '#5d5b73',
            },
            h3: {
                //title of sections with images
                fontSize: "1.8rem",
                fontFamily: "'Hellix', sans-serif",
                fontWeight: 600,
                color: '#B27394',
            },
            h4: {
                //title of blocks
                fontSize: "1.7rem",
                fontFamily: "'Hellix-Medium', sans-serif",
                color: '#0B0A1A',
                letterSpacing: 0,
                lineHeight: 1.18,
            },
            h5: {
                //checkboxes text
                fontSize: "1.6rem",
                fontFamily: "'Hellix-Medium', sans-serif",
                color: '#B27394',
                letterSpacing: 0,
            },
            body2: {
                //text on the sidebar
                fontSize: '1.36rem',
                fontWeight: 600,
                letterSpacing: "normal",
                color: '#FFFFFF',
                lineHeight: 1.24,
            },
            subtitle1: {
                //Pixel connection, upload file subtitle
                fontSize: '2.1rem',
                lineHeight: 'normal',
                letterSpacing: 'normal',
                color: '#685d74'
            },
            button: {
                fontSize: "1.4rem",
            },
        },
        components: {
            MuiCssBaseline: {
                styleOverrides: (theme) => ({
                    html: {
                        fontSize: 10,
                        [theme.breakpoints.down("lg")]: {
                            fontSize: 9,
                        },
                        [theme.breakpoints.down("br1024")]: {
                            fontSize: 8,
                        },
                        [theme.breakpoints.down("md")]: {
                            fontSize: 10,
                        },
                        [theme.breakpoints.down("sm")]: {
                            fontSize: 9,
                        },
                        [theme.breakpoints.down("br480")]: {
                            fontSize: 8,
                        },
                    },
                }),
            },
            MuiContainer: {
                styleOverrides: {
                    root: ({theme}) => ({
                        [theme.breakpoints.up("lg")]: {
                            maxWidth: "152rem",
                        },
                    }),
                },
            },
            MuiButton: {
                defaultProps: {
                    variant: "contained",
                },
                styleOverrides: {
                    root: {
                        textTransform: "none",
                        boxShadow: 'none',
                        borderRadius: '2.5rem',

                        '&:hover': {
                            boxShadow: 'none',
                        }
                    }
                }
            },
            MuiOutlinedInput: {
                styleOverrides: {
                    root: {
                        color: "rgba(99,110,149,0.5)",
                        fontSize: "1.4rem",
                        borderColor: "#9FB0C6",
                        borderRadius: 10,
                        "&:focus": {
                            color: "#9FB0C6",
                            borderColor: "#9FB0C6",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                            color: "#7C88B1",
                            borderColor: "#9FB0C6",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderWidth: 1,
                            borderColor: "#9FB0C6",
                        },
                    },
                },
            },
            MuiTextField:{
                defaultProps:{
                    autoComplete: "off"
                }
            }
        }
    })
;

export default theme;